<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      size="small"
      :height="300"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:rateOfProgress="{ row }">
        <div>
          <b-progress
            :variant="
              row.rateOfProgress <= 20
                ? 'danger'
                : row.rateOfProgress > 20 && row.rateOfProgress <= 40
                ? 'warning'
                : row.rateOfProgress > 40 && row.rateOfProgress <= 60
                ? 'secondary'
                : row.rateOfProgress > 60 && row.rateOfProgress <= 80
                ? 'info'
                : row.rateOfProgress > 80
                ? 'success'
                : ''
            "
            height="0.5rem"
            style="width: 200px"
            :value="row.rateOfProgress"
            animated
          ></b-progress>
          <p style="font-size: 12px;margin:0px;">
            {{ $l('tips_input_rateOfProgress') || 'Completion' }}:
            {{ row.rateOfProgress }}%
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  components: {},
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    },
    disabled: Boolean
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true
      },
      tableColumns: tableColumns(this)
    }
  },
  methods: {}
}
</script>
